<template>
  <el-select
    v-model="value"
    :disabled="disabled"
    :clearable="clearable"
    :placeholder="placeholder"
    @update:modelValue="update"
    @clear="update"
  >
    <el-option
      v-for="item in items"
      :key="item.key"
      :label="item.label"
      :value="item.key"
    />
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import { AdaptiveBannerSize, Size, SizeLabel, SizeLabels } from '@/api/types'

type SizeEntry = {
  key: Size
  label: string
  disabled: boolean
}

export default defineComponent({
  name: 'SizeSelect',
  props: {
    modelValue: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    includeAdaptive: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'All'
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const items = SizeLabels.map<SizeEntry>((item: SizeLabel) => {
      return {
        key: item.id,
        label: item.label,
        disabled: false
      }
    })

    if (props.includeAdaptive) {
      items.push({
        key: AdaptiveBannerSize.id,
        label: AdaptiveBannerSize.label,
        disabled: false
      })
    }

    const update = (newValue: Size) => {
      context.emit('update:modelValue', newValue)
    }
    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )
    return { update, items, value }
  }
})
</script>
